<table class="magic_box student-magic-box-preview" [ngStyle]="{'width': getWidth(card_format), 'height': getHeight(card_format), 'margin-left': getMargin(card_format)}">
  <tr *ngFor="let row of mb_body">
    <td *ngFor="let elem of row">
      {{ elem }}
    </td>
  </tr>
</table>
